import React from 'react'
import { motion } from 'framer-motion'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiStar } = FiIcons

const Pricing = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
            Simple Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Professional signatures at an affordable price
          </p>
        </motion.div>

        <motion.div 
          className="max-w-md mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-primary-600 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-semibold flex items-center space-x-1">
                <SafeIcon icon={FiStar} className="text-yellow-300" />
                <span>Limited Time</span>
              </span>
            </div>
            
            <div className="text-center mb-8 mt-4">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Professional Signature</h3>
              <div className="mb-4">
                <span className="text-5xl font-bold text-gray-900">€14.95</span>
                <span className="text-gray-500 line-through ml-2">€29.95</span>
              </div>
              <p className="text-gray-600">Per signature • All formats included</p>
            </div>

            <ul className="space-y-4 mb-8">
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiStar} className="text-green-500" />
                <span>3 AI-generated variations</span>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiStar} className="text-green-500" />
                <span>High-resolution upscaling</span>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiStar} className="text-green-500" />
                <span>JPG, PNG & SVG formats</span>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiStar} className="text-green-500" />
                <span>Commercial usage rights</span>
              </li>
              <li className="flex items-center space-x-3">
                <SafeIcon icon={FiStar} className="text-green-500" />
                <span>Instant download</span>
              </li>
            </ul>

            <div className="text-center">
              <motion.button
                className="w-full bg-primary-600 text-white py-4 rounded-lg text-lg font-semibold hover:bg-primary-700 transition-colors"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => {
                  const element = document.getElementById('generate')
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' })
                  }
                }}
              >
                Get Started - €14.95
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default Pricing